import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { MdEuro, MdOutlineAccountBalanceWallet } from 'react-icons/md';

type WalletTransaction = {
    _id?: string;
    amount: number;
    reason: string;
    adminEmail: string;
    createdAt: string;
};

const BuyerWallet = () => {
    const nav = useNavigate();
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [transactions, setTransactions] = useState<WalletTransaction[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        axios
            .get(`${CONFIG.apiUrl}/user/wallet`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setWalletBalance(res.data.walletBalance || 0);
                setTransactions(res.data.walletTransactions || []);
            })
            .catch((err) => {
                console.error('Error fetching wallet:', err);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="flex flex-col gap-4">
            {/* Header */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-brown-soft">
                        <MdOutlineAccountBalanceWallet className="h-5 w-5 text-leadrs-brown-focus" />
                    </div>
                    <div>
                        <h2 className="font-crimson text-2xl font-semibold leading-tight text-leadrs-text">
                            Mon portefeuille
                        </h2>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Consultez le solde de votre cagnotte et l&apos;historique de vos transactions.
                        </p>
                    </div>
                </div>
            </div>

            {/* Balance */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <div className="flex items-center gap-4">
                    <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-leadrs-yellow-soft">
                        <MdEuro className="h-5 w-5 text-leadrs-yellow-focus" />
                    </div>
                    <div>
                        <p className="font-geist text-sm text-leadrs-text-soft">Solde disponible</p>
                        {loading ? (
                            <p className="font-crimson text-3xl font-semibold text-leadrs-text">—</p>
                        ) : (
                            <p className="font-crimson text-3xl font-semibold text-leadrs-text">
                                {walletBalance.toFixed(2)} €
                            </p>
                        )}
                        <span
                            onClick={() => nav('/admin/wallet/topup')}
                            className="cursor-pointer font-geist text-sm text-leadrs-brand underline hover:opacity-80"
                        >
                            + Ajouter des crédits
                        </span>
                    </div>
                </div>
            </div>

            {/* Transaction history */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <p className="mb-4 font-crimson text-xl font-semibold text-leadrs-text">
                    Historique des transactions
                </p>

                {loading ? (
                    <p className="text-center font-geist text-sm text-leadrs-text-soft">Chargement...</p>
                ) : transactions.length === 0 ? (
                    <p className="text-center font-geist text-sm text-leadrs-text-soft">
                        Aucune transaction pour le moment.
                    </p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-leadrs-stroke">
                                    <th className="pb-3 text-left font-geist text-xs font-semibold uppercase tracking-wide text-leadrs-text-soft">
                                        Date
                                    </th>
                                    <th className="pb-3 text-left font-geist text-xs font-semibold uppercase tracking-wide text-leadrs-text-soft">
                                        Montant
                                    </th>
                                    <th className="pb-3 text-left font-geist text-xs font-semibold uppercase tracking-wide text-leadrs-text-soft">
                                        Raison
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map((tx, i) => (
                                    <tr key={tx._id || i} className="border-b border-leadrs-stroke last:border-0">
                                        <td className="py-3 font-geist text-sm text-leadrs-text-soft">
                                            {new Date(tx.createdAt).toLocaleDateString('fr-FR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                            })}
                                        </td>
                                        <td className="py-3">
                                            <span
                                                className={`font-geist text-sm font-semibold ${
                                                    tx.amount >= 0 ? 'text-leadrs-success' : 'text-leadrs-text'
                                                }`}
                                            >
                                                {tx.amount >= 0 ? '+' : ''}
                                                {tx.amount.toFixed(2)} €
                                            </span>
                                        </td>
                                        <td className="py-3 font-geist text-sm text-leadrs-text-soft">
                                            {tx.reason || '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BuyerWallet;
